var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNice1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 381,
    viewBox: "0 0 434 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5517_10058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.95 21.9675L216.728 87.9887L150.707 21.9675V-28H96.3242V44.4428L216.728 164.846L337.332 44.4428V-28H282.95V21.9675Z",
    fill: "#181818",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.707 330.793L216.928 264.772L282.95 330.793V380.761H337.332V308.318L216.928 188.115L96.3242 308.318V380.761H150.707V330.793Z",
    fill: "#181818",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.686 243.306L317.664 177.084L383.686 110.862H433.653V56.6802H361.21L240.807 177.084L361.21 297.487H433.653V243.306H383.686Z",
    fill: "#181818",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9675 110.862L115.989 177.284L49.9675 243.306H0V297.487H72.4428L192.846 177.284L72.4428 56.6802H0V110.862H49.9675Z",
    fill: "#181818",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5517_10058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 433.654,
    height: 408.77,
    fill: "white",
    transform: "translate(0 -28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNice1);
export default __webpack_public_path__ + "static/media/nice_1.15650f5b2ff54d7b6fc5683f0a48347a.svg";
export { ForwardRef as ReactComponent };